module.exports = __webpack_public_path__ + "static/media/plus_button.93f8482a.svg";